<label [for]="id" [ngClass]="['control-label', _labelClass]">{{ label + '&nbsp;:' }}</label>
<div [ngClass]="_fieldClass">
	<multi-extended-filterable-select
		[id]="id"
		[disabled]="disabled"
		[maxNumberOfSelections]="maxNumberOfSelections"
		[preselectionFunction]="isOuvragePreselected"
		[list]="ouvrages"
		[labelGetter]="getOuvrageLabel"
		[categoryList]="sousParcs"
		[categoryLabelGetter]="getSousParcLabel"
		[wildcardCategoryLabel]="'... dans le parc au complet'"
		[categoryChecker]="checkCategory"
		[reinitCommands]="reinitSubject"
		(selectedItemsChange)="onSelectedOuvragesChange($event)"
		>
	</multi-extended-filterable-select>
</div>